import { Component, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LoadingController, ModalController, NavController } from '@ionic/angular';
import { CellClickedEvent, ColDef, SelectionChangedEvent } from 'ag-grid-community';
import { IProperty } from 'src/app/interfaces/property.interface';
import { PropertyService } from 'src/app/services/property.service';
import { PropertyAdminModal } from './property-admin-modal/property-admin-modal';
import { AgGridAngular } from 'ag-grid-angular';
import { fmtDate, getCreatedDate } from 'src/app/util/util';
import * as _ from 'lodash'

const fmtIsoDate = d => fmtDate(d, 'YYYY-MM-DD hh:mma')

interface Table { cols: ColDef[], defColDef: ColDef }
const propertiesTable: Table = {
  cols: [
    {
      field: 'address', 
      headerName: 'Address',
      valueGetter: p => {
        try {
          const address = p.data.search_formatted_address || p.data.formatted_address
          if (!address) throw 'No viable address'
          return address.replace(', USA', '')
        } catch(e) {
          console.error('Error loading address: ', e)
          return 'Error'
        }
      },
      headerCheckboxSelection: true,
      checkboxSelection: true,
      flex: 1,
    },
    {
      field: 'comps',
      headerName: 'Comps',
      valueGetter: p => p.data.zillowFinalComps.finalComps.length,
      width: 100,
    },
    {
      field: 'createdAt',
      headerName: 'Created Date',
      valueFormatter: p => fmtIsoDate(p.data.createdAt)
    }
  ],
  defColDef: {
		sortable: true,
		filter: true,
		resizable: true,
	},
}
	

@Component({
  selector: 'property-admin',
  templateUrl: 'property-admin.html',
  styleUrls: ['./property-admin.scss']
})

export class PropertyAdminPage {
  private properties: (IProperty & { createdAt: Date })[];

  // grid props
  cols: ColDef[] = propertiesTable.cols
	defColDef: ColDef = propertiesTable.defColDef
	@ViewChild(AgGridAngular) agGrid!: AgGridAngular

  selected: IProperty[] = []
  loading = false
	get displayedRows() { return this.agGrid.api.getDisplayedRowCount() || 0 }

  constructor(
    public nav: NavController,
    public propertyService: PropertyService,
    public titleService: Title,
    public modalCtrl: ModalController,
    public loadingCtrl: LoadingController
  ) { }

	// ------------------------------------ Button Events
  async load() {
    this.loading = true
    try {
      const unformattedProperties = await this.propertyService.search().toPromise()
      console.log('Properties: ', unformattedProperties)
      this.properties = unformattedProperties
        .map(p => ({ ...p, createdAt: getCreatedDate(p._id) }))
        .sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime())
    } catch (e) {
      console.error('Error loading properties: ', e)
      alert('Error loading properties')
    }
    this.loading = false
  }

  async delete(propertyIdx) {
    try {
    const property = this.properties[propertyIdx]
    const address = property.search_formatted_address ? property.search_formatted_address : property.formatted_address
    if (confirm(`Sure you want to delete ${address}?`)) {
      await this.propertyService.delete(property).toPromise();
      this.load()
    }
    } catch (e) {
      console.error('Error deleting property: ', e)
      alert('Error deleting property')
    }
  }

  async deleteProperties() {
    // const rows = this.gridOptions.api.getSelectedNodes()
    // console.log(rows)
    // const selected = rows.map(r => r.data)
    // const msg = `Delete ${rows.length} properties?\n\n${selected.map(s => `- ${s.search_formatted_address ? s.search_formatted_address : s.formatted_address}`).join('\n')}`
    // if (confirm(msg)) {
    //   const loader = await this.loadingCtrl.create({})
    //   await loader.present()
    //   await Promise.all(
    //     selected.map((property, i) => this.propertyService.delete(property).toPromise().catch(e => {
    //       console.log("ERROR DELETING PROPERTY ", property, e)
    //       alert(`Error deleting property ${i} - ${property.search_formatted_address ? property.search_formatted_address : property.formatted_address}`)
    //     }))
    //   )
    //   await this.loadGrid()
    //   loader.dismiss()
    // }
  }

  	// ------------------------------------ Grid Methods
	async onGridReady() {
		await this.load()
	}

	async onSelectionChanged(params: SelectionChangedEvent) {
		const selected = params.api.getSelectedNodes()
		this.selected = selected.map(row => row.data)
	}

	async onCellClicked(e: CellClickedEvent) {
    const property = this.agGrid.api.getSelectedNodes()[0].data
    const modal = await this.modalCtrl.create({
      component: PropertyAdminModal,
      componentProps: { property }
    })
    await modal.present()
  }

	// ------------------------------------ Other
  filterProperties(event) {
    const search = event.detail.value.toLowerCase()
		this.agGrid.api.setRowData(this.properties.filter(p => {
			const address = p.search_formatted_address || p.formatted_address
      const creationDate = fmtIsoDate(p.createdAt)
      return address.toLowerCase().includes(search) || creationDate.includes(search)
		}))
  }
}
